import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const reviews = [{
  id: 1,
  name: 'María G.',
  rating: 5,
  text: 'Increíble experiencia. El chuletón estaba en su punto perfecto y el trato de Laura es excepcional. Sin duda el mejor restaurante de la zona. Volveremos seguro.',
  time: 'Hace 2 meses'
}, {
  id: 2,
  name: 'Carlos R.',
  rating: 5,
  text: 'Fuimos a celebrar un cumpleaños y todo salió perfecto. El cochinillo estaba espectacular y los postres caseros son una delicia. Ambiente muy acogedor.',
  time: 'Hace 1 mes'
}, {
  id: 3,
  name: 'Ana P.',
  rating: 5,
  text: 'El menú del día es una maravilla por el precio que tiene. Productos frescos y cocinados con mucho cariño. Se nota que aquí se cocina de verdad.',
  time: 'Hace 3 meses'
}, {
  id: 4,
  name: 'Javier M.',
  rating: 4,
  text: 'Muy buena comida casera y tradicional. Las carnes a la brasa son de lo mejor que he probado. El sitio es pequeño pero con mucho encanto.',
  time: 'Hace 2 semanas'
}];
export function ReviewsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % reviews.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  const nextReview = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % reviews.length);
  };
  const prevReview = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + reviews.length) % reviews.length);
  };
  return <section id="resenas" className="py-24 bg-laura-wood text-laura-cream overflow-hidden" data-id="element-277">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-278">
        <div className="text-center mb-16" data-id="element-279">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-laura-amber text-sm font-bold uppercase tracking-[0.2em] mb-4 block" data-id="element-280">
            Lo que dicen nuestros clientes
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-playfair mb-8" data-id="element-281">
            Valoraciones en Google
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col items-center justify-center space-y-2" data-id="element-282">
            <div className="flex items-center space-x-4" data-id="element-283">
              <span className="text-6xl font-playfair font-bold text-laura-cream" data-id="element-284">
                4.6
              </span>
              <div className="flex flex-col items-start" data-id="element-285">
                <div className="flex space-x-1" data-id="element-286">
                  {[1, 2, 3, 4].map(star => <StarIcon key={star} className="w-6 h-6 fill-laura-amber text-laura-amber" data-id="element-287" />)}
                  <div className="relative" data-id="element-288">
                    <StarIcon className="w-6 h-6 text-laura-amber" data-id="element-289" />
                    <div className="absolute inset-0 overflow-hidden w-[60%]" data-id="element-290">
                      <StarIcon className="w-6 h-6 fill-laura-amber text-laura-amber" data-id="element-291" />
                    </div>
                  </div>
                </div>
                <div className="flex items-center mt-1 space-x-2" data-id="element-292">
                  <div className="w-5 h-5 bg-white rounded-full flex items-center justify-center" data-id="element-293">
                    <span className="text-blue-600 font-bold text-sm" data-id="element-294">G</span>
                  </div>
                  <span className="text-laura-beige/80 text-sm" data-id="element-295">
                    62 reseñas en Google
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="relative max-w-4xl mx-auto" data-id="element-296">
          <button onClick={prevReview} className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-12 w-12 h-12 items-center justify-center rounded-full bg-laura-dark border border-laura-amber/30 text-laura-amber hover:bg-laura-amber hover:text-laura-dark transition-colors z-10" aria-label="Review anterior" data-id="element-297">
            <ChevronLeftIcon size={24} data-id="element-298" />
          </button>

          <button onClick={nextReview} className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-12 w-12 h-12 items-center justify-center rounded-full bg-laura-dark border border-laura-amber/30 text-laura-amber hover:bg-laura-amber hover:text-laura-dark transition-colors z-10" aria-label="Siguiente review" data-id="element-299">
            <ChevronRightIcon size={24} data-id="element-300" />
          </button>

          <div className="overflow-hidden px-4 py-8" data-id="element-301">
            <AnimatePresence mode="wait" data-id="element-302">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 50
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -50
            }} transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} className="bg-laura-dark/50 backdrop-blur-sm rounded-lg p-8 md:p-12 border border-laura-amber/20 shadow-2xl" data-id="element-303">
                <div className="flex flex-col items-center text-center space-y-6" data-id="element-304">
                  <div className="flex space-x-1" data-id="element-305">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-5 h-5 ${i < reviews[currentIndex].rating ? 'fill-laura-amber text-laura-amber' : 'text-laura-amber/30'}`} data-id="element-306" />)}
                  </div>

                  <p className="text-xl md:text-2xl font-playfair italic text-laura-beige leading-relaxed" data-id="element-307">
                    "{reviews[currentIndex].text}"
                  </p>

                  <div className="pt-4 border-t border-laura-amber/20 w-16 mx-auto" data-id="element-308" />

                  <div data-id="element-309">
                    <p className="font-bold text-lg text-laura-cream" data-id="element-310">
                      {reviews[currentIndex].name}
                    </p>
                    <p className="text-sm text-laura-beige/60 mt-1" data-id="element-311">
                      {reviews[currentIndex].time}
                    </p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="flex justify-center space-x-3 mt-8" data-id="element-312">
            {reviews.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-3 h-3 rounded-full transition-colors duration-300 ${index === currentIndex ? 'bg-laura-amber' : 'bg-laura-dark border border-laura-amber/50'}`} aria-label={`Ir a la reseña ${index + 1}`} data-id="element-313" />)}
          </div>
        </div>
      </div>
    </section>;
}